import { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";

export default function AccountingEntriesPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    fetch("/AccountingEntry", {
      headers: { 
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
      .then(r => r.json())
      .then(d => { 
        const items = d.data?.items ?? d.data ?? d ?? [];
        setData(items); 
        setLoading(false); 
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 text-right" dir="rtl">
      <h1 className="text-2xl font-bold mb-6">القيود المحاسبية</h1>
      {loading ? <p>جاري التحميل...</p> : (
        <div className="grid gap-4">
          {data.length === 0 ? <p>لا توجد بيانات</p> : data.map((item: any, i: number) => (
            <Card key={i}>
              <CardContent className="p-4">
                <div className="flex justify-between">
                  <span>{item.description}</span>
                  <span>{item.amount} د.أ</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
